import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

const getEmptyState = (fetching = false) => ({isFetching: fetching || false, locations: []});

const sanitizeEntity = ({id, venueId, ...entity}) => ({
    id: Number(id),
    venueId: Number(venueId) || null,
    ...entity
});

class LocationStore extends ReduceStore {
    getInitialState() {
        return getEmptyState();
    }

    isFetching() {
        return !!this.getState().isFetching;
    }

    getAll() {
        return this.getState().locations;
    }

    getAllByVenue(venueId) {
        venueId = Number(venueId);
        return this.getState().locations.filter(l => l.venueId === venueId);
    }

    getById(id) {
        id = Number(id);
        return this.getState().locations.find(l => l !== undefined && l.id === id);
    }

    getIndex({id}) {
        return this._state.locations.findIndex(l => l !== undefined && l.id === id);
    }
    
    reduce(state, action) {
        let index, location, command;
        switch (action.type) {
            case ActionTypes.LOCATION_LIST_REQUEST:
                return update(this.getState(), {isFetching: { $set: true }});

            case ActionTypes.LOCATION_LIST_SUCCESS:
                return update(this.getState(), {
                    isFetching: { $set: false },
                    locations: { $set: action.data.map(sanitizeEntity) }
                });

            case ActionTypes.LOCATION_LIST_FAILURE:
                return update(this.getState(), {isFetching: { $set: false }});

            case ActionTypes.LOCATION_INFO_REQUEST:
                return update(this.getState(), {isFetching: {$set: true}});

            case ActionTypes.LOCATION_INFO_SUCCESS:
                location = sanitizeEntity(action.data);
                index = this.getIndex(location);
                if (-1 < index) {
                    command = { [index]: { $set: location } };
                } else {
                    command = { $push: [ location ] };
                }
                return update(this.getState(), {
                    isFetching: {$set: false},
                    locations: command
                });

            case ActionTypes.LOCATION_INFO_FAILURE:
                return update(this.getState(), {isFetching: {$set: false}});

            case ActionTypes.LOCATION_SAVE_REQUEST:
                return update(this.getState(), {isFetching: {$set: true}});

            case ActionTypes.LOCATION_SAVE_SUCCESS:
                return update(this.getState(), {
                    isFetching: { $set: false },
                    locations: { $push: [ sanitizeEntity(action.data) ] }
                });

            case ActionTypes.LOCATION_SAVE_FAILURE:
                return update(this.getState(), {isFetching: {$set: false}});

            case ActionTypes.LOCATION_UPDATE_REQUEST:
                return update(this.getState(), {isFetching: {$set: true}});

            case ActionTypes.LOCATION_UPDATE_SUCCESS:
                location = sanitizeEntity(action.data);
                index = this.getIndex(location);
                return update(this.getState(), {
                    isFetching: {$set: false},
                    locations: { [index]: { $set: location } }
                });

            case ActionTypes.LOCATION_UPDATE_FAILURE:
                return update(this.getState(), {isFetching: {$set: false}});

            case ActionTypes.LOCATION_DELETE_REQUEST:
                return update(this.getState(), {isFetching: {$set: true}});

            case ActionTypes.LOCATION_DELETE_SUCCESS:
                index = this.getIndex(action.payload.current);
                if (-1 === index) { return update(this.getState(), {isFetching: {$set: false}}); }
                return update(this.getState(), {
                    isFetching: {$set: false},
                    locations: { $splice: [ [index, 1] ] }
                });

            case ActionTypes.LOCATION_DELETE_FAILURE:
                return update(this.getState(), {isFetching: {$set: false}});
        
            default:
                return state;
        }
    }
}

export default new LocationStore(CentricDispatcher);
